<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";

export default {
  extends: baseList,
  components: {
    info: Info,
  },
  data() {
    return {
      table: {
        mname: "seize",
        key: "id",
        url: {
          list:"/maintainer/maintainer/workOrder/seize",
        },
        output: false,
      },
      menus: [
        {
          label: "待处理",
          name: "workOrder_await_weixiu",
          auth: "system/workOrder/index",
          badge: { mname: "workstate", scene: "1",url:"/maintainer/maintainer/workOrder/state" },
        },
        {
          label: "处理中",
          name: "workOrder_processing_weixiu",
          auth: "system/processing/index",
          badge: { mname: "workstate", scene: "2",url:"/maintainer/maintainer/workOrder/state" },
        },
        {
          label: "已完成",
          name: "workOrder_completed_weixiu",
          auth: "system/completed/index",

        },
        // {
        //   label: "工单类型",
        //   name: "worktype_list",
        //   auth: "system/worktype/index",
        // },
          {
              label: "抢单池",
              name: "seize_weixiu",
            badge: { mname: "workstate", scene: "4",url:"/maintainer/maintainer/workOrder/state" },
          },
      ],
      query: {
          sendType:3,
        state:1
      },
      actions: [
      ],
        filters: [
            {
                label: "报修时间",
                KeyEnter: this.search,
                name: "",
                value: "",
                type: "datetimerange",
            },
            {
                label: "工单类型",
                name: "typeId",
                value: "",
                KeyEnter: this.search,
                type: "select",
                dropList: [],
            },
            {
                label: "报修人电话",
                name: "repairPhone",
                value: "",
                KeyEnter: this.search,
                type: "input",
            },
            {
                label: "报修人",
                KeyEnter: this.search,
                name: "repairBy",
                value: "",
                type: "input",
            },
            {
                label: "资产名称",
                name: "facilityName",
                value: "",
                KeyEnter: this.search,
                type: "input",
            },
            {
                label: "问题描述",
                KeyEnter: this.search,
                name: "descr",
                value: "",
                type: "input",
            },
            {
                label: "科室",
                name: "department",
                value: "",
                KeyEnter: this.search,
                type: "input",
            },
            {
                label: "资产编号",
                KeyEnter: this.search,
                name: "facilityNo",
                value: "",
                type: "input",
            },
            {
                label: "报修方式",
                name: "repairType",
                value: "",
                KeyEnter: this.search,
                type: "select",
                dropList: [
                    {
                        value:1,
                        name:"电话报修"
                    },
                    {
                        value:2,
                        name:"扫码报修"
                    },
                    {
                        value:3,
                        name:"移动报修"
                    },
                    {
                        value:4,
                        name:"后台设备报修"
                    },
                    {
                        value:5,
                        name:"后台科室报修"
                    },
                    {
                        value:6,
                        name:"维修员"
                    },
                    {
                        value:7,
                        name:"用户PC普通"
                    },
                    {
                        value:8,
                        name:"用户PC快速"
                    },
                ],
            },
        ],
        tableCols: [
            {
                title: "序号",
                type: "index",
                width: 80,
                align: "center",
            },
            {
                title: "问题描述",
                key: "descr",
                width: 280,
                align: "left",
                tooltip: "true",
            },
            {
                title: "工单类型",
                key: "typeName",
                minWidth: 120,
                align: "left",
                tooltip: "true",
            },
            {
                title: "报修时间",
                minWidth: 150,
                align: "center",
                key: "repairTime",
                sortable: true,
                render: (h, params) => {
                    const row = params.row;
                    const text = row.createTime.slice(0, 16);
                    return <span>{text}</span>;
                },
            },
            {
                title: "所在科室",
                key: "department",
                minWidth: 100,
                align: "left",
                tooltip: "true",
            },
            {
                title: "具体位置",
                key: "address",
                minWidth: 120,
                align: "left",
                tooltip: "true",
            },
            {
                title: "报修人",
                minWidth: 100,
                align: "left",
                key: "repairBy",
                sortable: true,
                tooltip: "true",
            },
            {
                title: "报修电话",
                key: "repairPhone",
                minWidth: 130,
                align: "left",
                copy: true,
            },
            {
                title: "协同工单",
                key: "isSynergy",
                minWidth: 100,
                align: "center",
                render: (h, params) => {
                    const row = params.row;
                    const text = row.isSynergy === 0 ? "否" : "是";
                    return <span style={{ "font-size": "14px" }}>{text}</span>;
                },
            },

            {
                title: "状态",
                key: "state",
                minWidth: 100,
                align: "center",
                render: (h, params) => {
                    const row = params.row;
                    const text = row.state === 1 && row.sendType === 3 ? "待抢单" : "";
                    return <span style={{ "font-size": "14px" }}>{text}</span>;
                },
            },
            {
                title: "报修来源",
                key: "repairSource",
                minWidth: 120,
                align: "center",
                render: (h, params) => {
                    const row = params.row;
                    const text =
                        row.repairSource === 1 && row.isFastOrder === 0
                            ? "扫码报修"
                            : row.repairSource === 1 && row.isFastOrder === 1
                            ? "移动报修"
                            : row.repairSource === 4
                                ? "电话报修"
                                : row.repairSource === 5 && row.isFastOrder === 0
                                    ? "用户PC普通"
                                    : row.repairSource === 5 && row.isFastOrder === 1
                                        ? "用户PC快速"
                                        : row.repairSource === 3 && row.isFastOrder === 0
                                            ? "后台设备报修"
                                            : row.repairSource === 3 && row.isFastOrder === 1
                                                ? "后台科室报修"
                                                : row.repairSource === 2
                                                    ? "维修员"
                                                    : "";
                    return <span style={{ "font-size": "14px" }}>{text}</span>;
                },
            },
            {
                title: "操作",
                align: "center",
                width: 190,
                key: "handle",
                fixed: "right",
                handle: [
                  (vm, h, currentRow, param) => {
                    // let directives = [];
                    const row = param.row;
                    if (row.isSynergy == 0) {
                      return (
                          <Button
                              size="small"
                              onClick={() => this.handleChange(currentRow)}
                              type="default"
                              style={{
                                border:"none",
                                color: "#4991ff",marginLeft: "5px" }}
                          >
                            立即抢单
                          </Button>
                      );
                    }
                  },
                    (vm, h, currentRow, param) => {


                        return (
                            <Button
                        size="small"
                        onClick={() => this.toInfo(currentRow)}
                        type="default"
                        style={{
                            border:"none",
                                color: "#4991ff", }}
                    >
                        详情
                        </Button>
                    );
                    },
                ],
            },
        ],
    };
  },
  created() {
    this.loadLevelDatas();
  },
  methods: {
    async handleChange(row) {
      let q = {}
      q.id = row.id;
      let res = await $utils.api.load(`/maintainer/maintainer/workOrder/startPcMaintain`, q,"post");
      try {
        if (res && res.code == 200) {
          this.search()
        }
      }catch (e) {
        console.log(e)
      }
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/maintainer/maintainer/workType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (
                  element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },
  },
};
</script>
<style scoped></style>
